import { IConstraintFacilityExpansionDetail } from '../../interfaces/iconstraint-facility-expansion-detail';
import { Area } from '../area';
import { ConstraintFacilityExpansion } from '../constraint-facility-expansion';

export class ConstraintFacilityExpansionDetailBase {
  ConstraintFacilityExpansionDetailId: number;
  ConstraintFacilityExpansionId: number;
  AreaId: number | null;
  EffectiveStartDate: Date | null;
  EffectiveFinishDate: Date | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Area?: Area;
  ConstraintFacilityExpansion?: ConstraintFacilityExpansion;

  constructor(item?: IConstraintFacilityExpansionDetail) {
    if (item) {

      this.ConstraintFacilityExpansionDetailId = item.ConstraintFacilityExpansionDetailId;
      this.ConstraintFacilityExpansionId = item.ConstraintFacilityExpansionId;
      this.AreaId = item.AreaId;
      this.EffectiveStartDate = item.EffectiveStartDate ? new Date(item.EffectiveStartDate) : null;
      this.EffectiveFinishDate = item.EffectiveFinishDate ? new Date(item.EffectiveFinishDate) : null;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Area = new Area(item.Area);
      this.ConstraintFacilityExpansion = new ConstraintFacilityExpansion(item.ConstraintFacilityExpansion);
    }
  }
}